import React from 'react';
import PageMenu from './PageMenu';

function MenuFind(props) {
  return (
    <PageMenu
      {...props}
      title="Contact Us Menu"
      items={[
        {
          name: 'contact-us',
          title: 'Contact Us',
        },
        {
          name: 'warranty-information-request',
          title: 'Warranty Information & Requests',
        },
        {
          name: 'realtor-contact',
          title: 'Realtor Contact',
        },
        {
          name: 'vendor-registration',
          title: 'Vendor Registration',
        },
      ]}
    />
  );
}

export default MenuFind;



// WEBPACK FOOTER //
// ./src/components/MenuContact.js